<template>
  <div class="dialogContainer" v-if="dialogVisible">
    <div class="dialogBox">
      <div class="dialogTitle SourceHanSansCN-Medium" v-html="title"></div>
      <div class="dialogContent SourceHanSansCN-Regular" v-html="content"></div>
      <div class="close_box" @click="closeDialog">
        <el-image :src="close_icon" class="close_icon"></el-image>
      </div>
      <!--<div class="dialogMenu">-->
      <!--  <div class="dialogBtn dialogCancelBtn" @click="closeDialog">取消</div>-->
      <!--  <div class="dialogBtn dialogSubmitBtn" @click="submitDialog">确定</div>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script setup>
import {defineExpose, ref} from 'vue'
import {imgCDN, imgVersion} from "@/common/js/config.default";

const close_icon = ref(imgCDN + "assets/components/mDialog/close.png?v=" + imgVersion);

const dialogVisible = ref(false);

const title = ref('');
const content = ref('');

const openDialog = (title1, content1) => {
  title.value = title1;
  content.value = content1;
  dialogVisible.value = true;
}

const closeDialog = () => {
  dialogVisible.value = false;
}

const submitDialog = () => {
  dialogVisible.value = false;
}

defineExpose({
  openDialog,
  closeDialog
})


</script>

<style scoped lang="scss">
.dialogContainer {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10001;

  .dialogBox {
    width: 80%;
    height: auto;
    background: #fff;
    border-radius: 0.2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 0.6rem .6rem .6rem;

    .dialogTitle {
      width: 100%;
      font-size: 0.28rem;
      text-align: center;
      margin-top: 0.4rem;
      font-weight: bold;

    }

    .dialogContent {
      width: 90%;
      //height: 5rem;
      font-size: 0.24rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0.3rem auto 0;
      line-height: normal;
    }

    .close_box {
      width: .5rem;
      height: .5rem;
      position: absolute;
      top: 0.14rem;
      right: 0.14rem;

      .close_icon {
        width: 0.16rem;
        height: 0.16rem;
        position: absolute;
        top: 0;
        right: 0;
      }
    }


    .dialogMenu {
      width: 100%;
      height: 1rem;
      display: flex;
      align-items: center;
      border-top: 1px solid #ccc;

      .dialogBtn {
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.3rem;
        letter-spacing: 0.04rem;

        &.dialogCancelBtn {
          border-right: 1px solid #ccc;
        }

        &.dialogSubmitBtn {
          color: #004393;
        }
      }
    }
  }
}
</style>
